import { Formik, FormikValues } from 'formik'
import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react'
import { Button, Card, Col, Form, FormControl, FormGroup, FormLabel, Row, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MultiValue, SingleValue } from 'react-select'
import { toast } from 'react-toastify'
import FormInputSelect from '../Form/FormInputSelect/FormInputSelect'
import FormInputText from '../Form/FormInputText/FormInputText'
import UserContext from '../../Context/UserContext'
import { documentFormatArray, INPUT_FIELD_ENUMS, MODULE_ID, MULTIPLICATION_CONSTANTS_FOR_MB_TO_BYTE, PROJECT_ROUTES_ENUMS } from '../../utils/enums/enums'
import { SelectDropdownModel, SingleOptionModel } from '../../Pages/Register/UserRegistrationModel'
import { addDriverDocumentSchema } from '../../Pages/DriverMenu/DriverDocument/addDriverDocumentSchema'
import { patchEditDocumentType, postDocumentCreate } from '../../Services/DriverService'
import { useNavigate, useParams } from 'react-router-dom'
import IsAuthorized from '../IsAuthorized/IsAuthorized'
import { fetchResponseMessage } from '../../utils/utils'
import _ from 'lodash'
import ImagePicker from './ImagePicker'

type Props = {
  field: {
    documentName: string,
    documentDescription: string,
    documentSize: number,
    documentImage: string,
    documentFormat: any,
    setDoShow: Dispatch<SetStateAction<boolean>>,
    setDoseExpiry: Dispatch<SetStateAction<boolean>>,
    setIsRequiredState: Dispatch<SetStateAction<boolean>>,
    setIsCaptureOnlyState: Dispatch<SetStateAction<boolean>>,
    setSelectedFormat: Dispatch<SetStateAction<MultiValue<SingleOptionModel>>>,
    setDocumentSizeState: Dispatch<SetStateAction<number>>,
    doShow: boolean,
    doseExpiry: boolean,
    isRequiredState: boolean,
    isCaptureOnlyState: boolean
  }
  isDisabled?: boolean
  cardTitle: string
  paramId?: string
  redirectTo?: string
  submitButtonName: string
  setFieldValue?: (formik: FormikValues) => void
  pageName: string
  noDataFetched?: boolean
}

const DriverDocumentCreateViewEdit = (props: Props) => {
  console.log('props.field.documentSize >> ', props.field.documentSize)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const params = useParams()
  const {
    isFetching,
    setIsFetching,
    setArrayOfBreadCrumb,
    setShowMediaModelDetails,
    setShowMediaModel
  } = useContext(UserContext)
  // const [selectedCountryCode, setSelectedCountryCode] = useState<SingleValue<SelectDropdownModel>>({} as SelectDropdownModel)

  useEffect(() => {
    setArrayOfBreadCrumb([
      { name: `${t('PAGE_NAME.HOME')}`, url: PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.HOME_PAGE },
      { name: `${t('PAGE_NAME.DRIVER_DOCUMENTS')}`, url: '' }
    ])
    return () => { }
  }, [])

  /**
  * @function editDesignationSubmit
  * @return void
  * @param value
  *@description To handle submit  after changes are made in  any Designation field
  */
  const editCreateDriverDocument = async (values: FormikValues, { resetForm }: FormikValues) => {
    if (props.pageName === 'view-driver-document') {
      navigate(`${PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.DRIVER_DOCUMENT_PAGE}/edit/${props.paramId}`)
    } else {
      setIsFetching(true)
      const fieldValue = {
        title: values.documentName,
        description: values.documentDescription,
        contentType: (values.documentFormat.map((format: any) => format.value)).toString(),
        maxSize: values.documentSize * MULTIPLICATION_CONSTANTS_FOR_MB_TO_BYTE,
        doShowDocumentNumber: props.field.doShow,
        doShowDocumentExpiryDate: props.field.doseExpiry,
        placeHolderImg: values.documentImage,
        isCaptureOnly: props.field.isCaptureOnlyState,
        isRequired: props.field.isRequiredState
      }
      // let toastType
      try {
        let response
        const lastParamsOfPath = location.pathname.split('/')[location.pathname.split('/').length - 1]
        if (lastParamsOfPath === 'add') {
          response = await postDocumentCreate(fieldValue)
        } else {
          response = await patchEditDocumentType(fieldValue, params.itemId!)
        }
        if (response.data) {
          const responseMessage = fetchResponseMessage(response.responseCode)
          toast.success(responseMessage)
          setIsFetching(false)
          resetForm()
          navigate(PROJECT_ROUTES_ENUMS.PRIVATE_ROUTES.DRIVER_DOCUMENT_PAGE)
        } else {
          throw response
        }
      } catch (error) {
        setIsFetching(false)
        console.error('🚀 ~ file: AddDesignation.tsx ~ line 52 ~ addDesignationSubmitHandler ~ error', error)
        if (error && _.has(error, 'response.data.responseCode')) {
          // @ts-ignore
          const responseMessage = fetchResponseMessage(error.response.data.responseCode)
          toast.error(responseMessage)
        }
      }
    }
  }

  const initialUserInfo = {
    documentName: props.field.documentName,
    documentDescription: props.field.documentDescription,
    // TODO : Renish - Need to check why this is not working
    documentSize: 8 || props.field.documentSize,
    documentImage: props.field.documentImage,
    // TODO : Renish - Need to check why this is not working
    // documentFormat: props.field.documentFormat
    documentFormat: [{ value: 'png', label: 'png' }, { value: 'pdf', label: 'pdf' }, { value: 'jpg', label: 'jpg' }, { value: 'jpeg', label: 'jpeg' }]
  }
  const setSelection = (event: any, formik: FormikValues) => {
    props.field.setSelectedFormat(event)
    console.log('🚀 ~ file: DriverDocumentCreateViewEdit.tsx:131 ~ setSelection ~ formik.values', formik.values)
    // formik.values = {...formik.values, documentFormat:event}
    formik.values.documentFormat = event
  }

  const openMedia = (formik: FormikValues, inputName: string) => {
    function setFormikValue (newValue: string) {
      formik.setFieldValue(inputName, newValue)
    }
    setShowMediaModelDetails({ setInputState: setFormikValue, inputRef: null })
    setShowMediaModel(true)
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialUserInfo}
      validationSchema={() => addDriverDocumentSchema}
      onSubmit={(values: FormikValues, formik) => {
        editCreateDriverDocument(values, formik)
      }}
    >
      {(formik: FormikValues) => (
        <Form className="pt-3" onSubmit={formik.handleSubmit}>
          <fieldset disabled={props.isDisabled}>
            <Row>
              <Col sm={12} md={6} lg={4} xl={3}>
                <FormInputText
                  inputName={INPUT_FIELD_ENUMS.DOCUMENT_NAME.INPUT_NAME}
                  type={INPUT_FIELD_ENUMS.DOCUMENT_NAME.INPUT_TYPE}
                  isRequired={INPUT_FIELD_ENUMS.DOCUMENT_NAME.IS_REQUIRED}
                  inputField={'DOCUMENT_NAME'}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xl={3}>
                <FormInputText
                  inputName={INPUT_FIELD_ENUMS.DOCUMENT_DESCRIPTION.INPUT_NAME}
                  type={INPUT_FIELD_ENUMS.DOCUMENT_DESCRIPTION.INPUT_TYPE}
                  isRequired={INPUT_FIELD_ENUMS.DOCUMENT_DESCRIPTION.IS_REQUIRED}
                  inputField={'DOCUMENT_DESCRIPTION'}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xl={3}>
                <FormInputSelect
                  // TODO : Renish - Added hack for now
                  readOnly={true}
                  inputField={'DOCUMENT_FORMAT'}
                  isRequired={INPUT_FIELD_ENUMS.DOCUMENT_FORMAT.IS_REQUIRED}
                  inputName={INPUT_FIELD_ENUMS.DOCUMENT_FORMAT.INPUT_NAME}
                  options={documentFormatArray}
                  defaultSelected={props.field.documentFormat}
                  handleSelection={(event: MultiValue<SingleOptionModel> | SingleValue<SelectDropdownModel>) => {
                    setSelection(event, formik)
                  }}
                  isMulti={true}
                />
              </Col>
              <Col sm={12} md={6} lg={4} xl={3}>
                <FormGroup>
                  <FormLabel className='text-overflow-none mb-0'>{`${t('INPUT_FIELD_ENUMS.DOCUMENT_PLACE_HOLDING_IMAGE.LABEL_NAME')} :`}</FormLabel>
                  <ImagePicker openMedia={() => openMedia(formik, INPUT_FIELD_ENUMS.DOCUMENT_PLACE_HOLDING_IMAGE.INPUT_NAME)}>
                    <FormControl
                      className='form-control form-control-lg border-left-0 w-100 mb-1'
                      // TODO: from translation
                      name={INPUT_FIELD_ENUMS.DOCUMENT_PLACE_HOLDING_IMAGE.INPUT_NAME}
                      placeholder={`${t('INPUT_FIELD_ENUMS.DOCUMENT_PLACE_HOLDING_IMAGE.PLACEHOLDER')}`}
                      value={formik.values.documentImage}
                      onChange={(event) => formik.setFieldValue(INPUT_FIELD_ENUMS.DOCUMENT_PLACE_HOLDING_IMAGE.INPUT_NAME, event?.target.value)}
                    />
                  </ImagePicker>
                </FormGroup>
              </Col>
              <Col sm={12} md={6} lg={4} xl={3} className='my-2 text-center'>
                <Card className='form-card'>
                  <Card.Body className={'d-flex flex-column justify-content-between'}>
                    <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
                      <>
                        <FormLabel className='align-self-center mb-0 mt-1 text-truncate me-1'>{`${t('DRIVER_DOCUMENT_PAGE.DOCUMENT_ADD_PAGE.HAS_NUMBER')} :`}</FormLabel>
                      </>
                      <Form.Check type="switch" name="doShowNumber" className="switch d-block ms-auto" checked={props.field.doShow} onChange={(event) => props.field.setDoShow(event.target.checked)} />
                    </FormGroup>
                    <p className='text-left mt-4 text-secondary'>To enable the switch, Driver must have to enter Document Number. </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={6} lg={4} xl={3} className='my-2 text-center'>
                <Card className='form-card'>
                  <Card.Body className={'d-flex flex-column justify-content-between'}>
                    <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
                      <>
                        <FormLabel className='align-self-center mb-0 mt-1 text-truncate me-1'>{`${t('DRIVER_DOCUMENT_PAGE.DOCUMENT_ADD_PAGE.HAS_EXPIRY')} :`}</FormLabel>
                      </>
                      <Form.Check type="switch" name="documentExpiry" className="switch d-block ms-auto" checked={props.field.doseExpiry} onChange={(event) => props.field.setDoseExpiry(event.target.checked)} />
                    </FormGroup>
                    <p className='text-left mt-4 text-secondary'>To enable the switch, Driver must have to enter Document Expiry date. </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={6} lg={4} xl={3} className='my-2 text-center'>
                <Card className='form-card'>
                  <Card.Body className={'d-flex flex-column justify-content-between'}>
                    <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
                      <>
                        <FormLabel className='align-self-center mb-0 mt-1 text-truncate me-1'>{`${t('DRIVER_DOCUMENT_PAGE.DOCUMENT_ADD_PAGE.IS_REQUIRED')} :`}</FormLabel>
                      </>
                      <Form.Check type="switch" name="isRequired" className="switch d-block ms-auto" checked={props.field.isRequiredState} onChange={(event) => props.field.setIsRequiredState(event.target.checked)} />
                    </FormGroup>
                    <p className='text-left mt-4 text-secondary'>To enable the switch, Driver must have to Upload this Document (Mandatory for Driver). </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={6} lg={4} xl={3} className='my-2 text-center'>
                <Card className='form-card'>
                  <Card.Body className={'d-flex flex-column justify-content-between'}>
                    <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
                      <>
                        <FormLabel className='align-self-center mb-0 mt-1 text-truncate me-1'>{`${t('DRIVER_DOCUMENT_PAGE.DOCUMENT_ADD_PAGE.IS_CAPTURE_ONLY')} :`}</FormLabel>
                      </>
                      <Form.Check type="switch" name="isCaptureOnly" className="switch d-block ms-auto" checked={props.field.isCaptureOnlyState} onChange={(event) => props.field.setIsCaptureOnlyState(event.target.checked)} />
                    </FormGroup>
                    <p className='text-left mt-4 text-secondary'>To enable the switch, Driver can only take Picture cant upload from Gallery.   </p>
                  </Card.Body>
                </Card>
              </Col>
              {/* <Col sm={12} md={6} lg={4} xl={3} className='my-2 text-center'>
                <Card className='form-card'>
                  <Card.Body className={'d-flex flex-column justify-content-between'}>
                    <FormGroup className='my-2 switch-wrapper d-flex justify-content-between'>
                      <FormLabel className='align-self-center mb-0 mt-1 text-truncate me-1' >{`${t('INPUT_FIELD_ENUMS.DOCUMENT_SIZE.LABEL_NAME')} :`}</FormLabel>
                      <div className='d-flex justify-content-center'>
                        <input type="range" name="documentSize" className="range-style" value={+props.field.documentSize} min={1} max={30}
                          onChange={(event) => props.field.setDocumentSizeState(+event.target.value)} />
                      </div>
                    </FormGroup>
                    <p className='text-left mt-4 text-secondary'>By changing this option, Driver cannot upload document Grater than {props.field.documentSize} MB. </p>
                  </Card.Body>
                </Card>
              </Col> */}
            </Row>
          </fieldset>
          <FormGroup className="d-flex align-item-center justify-content-start">
            <IsAuthorized moduleInfo={[{ moduleId: MODULE_ID.ADMIN_DESIGNATION, rights: props.submitButtonName === 'ADD' ? 'create' : 'update' }]}>
              <Button type="submit" className='m-3 mw-50' disabled={props.noDataFetched}>
                {isFetching ? <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> : t(`PROJECT_BUTTON.${props.submitButtonName}`)}
              </Button>
            </IsAuthorized>
          </FormGroup>
        </Form>
      )}
    </Formik>
  )
}

export default DriverDocumentCreateViewEdit
